import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventType, Router } from '@angular/router';

export const fundsSearchParamName: string = 'fund';

function detectSelectedFund(): string | undefined {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(fundsSearchParamName);
}

@Injectable({ providedIn: 'root' })
export class RouteSelectedFund {
  private selectedFund: string | undefined = undefined;

  private readonly router = inject(Router);

  constructor() {
    this.refresh();
    this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
      switch (event.type) {
        case EventType.ResolveEnd:
        case EventType.NavigationEnd:
          this.refresh();
      }
    });
  }

  public refresh(): RouteSelectedFund {
    this.selectedFund = detectSelectedFund();
    return this;
  }

  public get(): string | undefined {
    return this.selectedFund;
  }
}
